import { useTranslation } from "react-i18next";
import { flowSteps } from "../../../mocks/process";

export default function FlowSection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-cream">
      <div className="container-main px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <span className="tag-label mb-3 inline-block">{t("process.flow.label")}</span>
          <h2 className="mb-3">{t("process.flow.title")}</h2>
          <p className="text-medium-gray max-w-2xl mx-auto">
            {t("process.flow.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {flowSteps.map((step, index) => (
            <div
              key={step.id}
              className="group bg-white rounded-xl p-5 md:p-6 border border-warm-gray/30 hover:border-champagne/40 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-start gap-4">
                <div className="shrink-0 w-11 h-11 md:w-12 md:h-12 rounded-full bg-graphite flex items-center justify-center transition-all duration-300 group-hover:bg-champagne group-hover:scale-110">
                  <span className="text-champagne font-bold text-base transition-colors duration-300 group-hover:text-graphite">{String(step.id).padStart(2, "0")}</span>
                </div>
                <div>
                  <h3 className="font-semibold text-graphite text-base md:text-base mb-1.5 leading-snug">
                    {t(step.title)}
                  </h3>
                  <p className="text-medium-gray text-base md:text-base leading-relaxed">
                    {t(step.desc)}
                  </p>
                </div>
              </div>

              {/* Connector line for mobile/tablet between cards */}
              {index < flowSteps.length - 1 && (
                <div className="hidden lg:block absolute" />
              )}
            </div>
          ))}
        </div>

        {/* Flow connector arrows */}
        <div className="hidden lg:flex justify-center mt-8 gap-1">
          {flowSteps.slice(0, -1).map((_, i) => (
            <div key={i} className="flex items-center">
              <div className="w-8 h-px bg-champagne/30" />
              <div className="w-0 h-0 border-l-4 border-l-champagne/30 border-y-4 border-y-transparent" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}